import spinModel from "../../model/SpinModel";
import { ICondition } from "../State";

export class IsInFreeSpinsCondition implements ICondition {
    public check(): boolean {
        return spinModel.isInFreespins() ;
    }
}